import { Flow } from '../interfaces';

export default (flow: Flow): string => {
    return flow.start;
};
